/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function NetworkRequestFromJSON(json) {
    return NetworkRequestFromJSONTyped(json, false);
}
export function NetworkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': json['active'],
        'allowedScreenPositions': !exists(json, 'allowedScreenPositions') ? undefined : json['allowedScreenPositions']
    };
}
export function NetworkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'active': value.active,
        'allowedScreenPositions': value.allowedScreenPositions
    };
}
